/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { SearchIndexActivation } from '../model/searchIndexActivation';
import { SearchIndexActivationCreateRequest } from '../model/searchIndexActivationCreateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class SearchIndexActivationService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createSearchIndexActivation
     * Activates the search index of the specific type.
     * @param searchIndexActivationCreateRequest the information needed to activate a search index
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchIndexActivationCreateSearchIndexActivation(searchIndexActivationCreateRequest: SearchIndexActivationCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<SearchIndexActivation>;
    public searchIndexActivationCreateSearchIndexActivation(searchIndexActivationCreateRequest: SearchIndexActivationCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchIndexActivation>>;
    public searchIndexActivationCreateSearchIndexActivation(searchIndexActivationCreateRequest: SearchIndexActivationCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchIndexActivation>>;
    public searchIndexActivationCreateSearchIndexActivation(searchIndexActivationCreateRequest: SearchIndexActivationCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (searchIndexActivationCreateRequest === null || searchIndexActivationCreateRequest === undefined) {
            throw new Error('Required parameter searchIndexActivationCreateRequest was null or undefined when calling searchIndexActivationCreateSearchIndexActivation.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SearchIndexActivation>(`${this.configuration.basePath}/searchIndexActivations`,
            searchIndexActivationCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
